/**
 * ResultPageMinimal — Legacy redirect
 *
 * This page has been replaced by the BottomSheet verdict flow
 * on CalculatorPage. This stub redirects any direct URL hits
 * to the portfolio page.
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function ResultPageMinimal() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/app/portfolio', { replace: true });
  }, [navigate]);

  return null;
}

export default ResultPageMinimal;
